// frontend/admin-portal/src/services/requisitionService.js
import api from './axiosConfig';

export const requisitionService = {
    list: async (params = {}) => {
        const { data } = await api.get('/requisitions', { params });
        return data.data;
    },
    get: async (id) => {
        const { data } = await api.get(`/requisitions/${id}`);
        return data.data.requisition;
    },
    create: async (payload) => {
        const { data } = await api.post('/requisitions', payload);
        return data.data.requisition;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/requisitions/${id}`, payload);
        return data.data.requisition;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/requisitions/${id}`);
        return data;
    },
    cancel: async (id) => {
        const { data } = await api.patch(`/requisitions/${id}/cancel`);
        return data.data.requisition;
    },
    send: async (id, payload) => {
        const { data } = await api.post(`/requisitions/${id}/send`, payload);
        return data.data;
    },
    comparison: async (id) => {
        const { data } = await api.get(`/requisitions/${id}/comparison`);
        return data.data;
    },
};